import { render, staticRenderFns } from "./Infographics.vue?vue&type=template&id=08492c7e&scoped=true&"
import script from "./Infographics.js?vue&type=script&lang=js&"
export * from "./Infographics.js?vue&type=script&lang=js&"
import style0 from "./Infographics.vue?vue&type=style&index=0&id=08492c7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08492c7e",
  null
  
)

export default component.exports